import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Select,
  Stack,
  useToast,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth, authApi } from '../hooks/useAuth';
import config from '../config';

const LeadForm = () => {
  const [formData, setFormData] = useState({
    customerName: '',
    customerEmail: '',
    customerPhone: '',
    customerAddress: '',
    investmentType: '',
    investmentAmount: '',
    notes: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const leadData = {
        customerName: formData.customerName.trim(),
        customerPhone: formData.customerPhone.trim(),
        customerEmail: formData.customerEmail.trim(),
        customerAddress: formData.customerAddress?.trim(),
        investmentType: formData.investmentType,
        investmentAmount: parseFloat(formData.investmentAmount),
        notes: formData.notes?.trim()
      };

      console.log('Submitting lead with data:', leadData);

      const response = await authApi.post('/api/leads', leadData);
      console.log('Server response:', response);

      if (response.data.success) {
        toast({
          title: 'Success',
          description: 'Lead submitted successfully!',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        navigate('/agent-dashboard');
      }
    } catch (error) {
      // Log the complete error object
      console.error('Complete error object:', error);
      console.error('Error response:', error.response);
      console.error('Error data:', error.response?.data);

      const errorMessage = 
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        'Failed to submit lead';

      console.error('Final error message:', errorMessage);
      
      toast({
        title: 'Error',
        description: errorMessage,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxW="container.md" py={8}>
      <Box p={8} shadow="lg" rounded="lg">
        <Stack spacing={4}>
          <Heading size="lg" textAlign="center">Submit New Lead</Heading>
          <form onSubmit={handleSubmit}>
            <Stack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Customer Name</FormLabel>
                <Input
                  name="customerName"
                  value={formData.customerName}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Customer Email</FormLabel>
                <Input
                  name="customerEmail"
                  type="email"
                  value={formData.customerEmail}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Customer Phone</FormLabel>
                <Input
                  name="customerPhone"
                  type="tel"
                  value={formData.customerPhone}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Customer Address</FormLabel>
                <Input
                  name="customerAddress"
                  value={formData.customerAddress}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Investment Type</FormLabel>
                <Select
                  name="investmentType"
                  value={formData.investmentType}
                  onChange={handleChange}
                >
                  <option value="">Select Investment Type</option>
                  <option value="mutual_funds">Mutual Funds</option>
                  <option value="SIP">SIP</option>
                  <option value="Lumpsum">Lumpsum</option>
                  <option value="Both">Both</option>
                </Select>
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Investment Amount (₹)</FormLabel>
                <Input
                  name="investmentAmount"
                  type="number"
                  min="1000"
                  step="100"
                  value={formData.investmentAmount}
                  onChange={handleChange}
                  placeholder="Enter amount in rupees"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Additional Notes</FormLabel>
                <Input
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Any additional information..."
                />
              </FormControl>

              <Button
                type="submit"
                colorScheme="blue"
                isLoading={isLoading}
                loadingText="Submitting..."
              >
                Submit Lead
              </Button>
            </Stack>
          </form>
        </Stack>
      </Box>
    </Container>
  );
};

export default LeadForm;
